import axios, { AxiosError } from 'axios';
import { Environment } from '../../environment';
import { Api } from './axios-config';

export interface IProducaoFazenda{
  dataproducao: Date;
  nome: string;
  numero: number;
  quantidade: number;
  subtotal: number;
  desconto: number;
  total: number;
}

export interface IListagemProducao {
    codcei: number;
    numero: string;
    produtor: string;
}

export interface IGeraProducao{
  datainicial: string;                   
  datafinal: string;  
}

export interface IRecibo {
  dataproducao: Date;
  nome: string;
  cpf: string;        
  quantidade: number;
  subtotal: number;
  desconto: number;
  total: number;
  produtor: string,
  numero: string;
}

type TCeiComTotalCount = {
    data: IListagemProducao[];
    totalCount: number;
}

interface ErrorResponse {
  error: {
    default: string;
  };
}

const getAll = async (page = 1, filter = ''): Promise<TCeiComTotalCount | Error> => {
  try {
    const urlRelativa = `/cei?page=${page}&limit=${Environment.LIMITE_DE_LINHAS}&filter=${filter}`;
    const { data, headers } = await Api.get(urlRelativa);
    if (data) {
      return {
        data,
        totalCount: Number(headers['x-total-count'] || Environment.LIMITE_DE_LINHAS),
      };
    }
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const producaofazenda = async (dataproducao: string, fazenda: number): Promise<IProducaoFazenda[] | Error> => {
  try {
    const urlRelativa = `/producaofazenda?dataproducao=${dataproducao}&codfaz=${fazenda}`;
    const { data } = await Api.get(urlRelativa);
    if (data) {
      return data;
    }
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const Recibo = async (dataproducao: string, fazenda: number): Promise<IRecibo[] | Error> => {
  try {
    const urlRelativa = `/recibos?dataproducao=${dataproducao}&codfaz=${fazenda}`;
    const { data } = await Api.get(urlRelativa);
    if (data) {
      return data;
    }
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const GeraProducao = async (inicial: string, final: string ): Promise<string | Error> => {
    try {
      const { data } = await Api.post<IGeraProducao>('/producao',  {datainicial: inicial, datafinal: final});
      if (Object.keys(data).length === 0) {
        return 'guuid';
      }
        return new Error('Erro ao criar o registro.');
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError<ErrorResponse>;
        if (axiosError.response) {
          const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
          return new Error(errorMessage);
        } else if (axiosError.request) {
          return new Error('Nenhuma resposta do servidor');
        } else {
          return new Error(axiosError.message);
        }
      } else {
        return new Error('Erro inesperado');
      }
    }
  };

  const GeraProducaoIndividual = async (guuidcolhedor: string, inicial: string, final: string ): Promise<string | Error> => {
    try {
      const { data } = await Api.post<IGeraProducao>('/producaoindividual',  {guuidcolhedor: guuidcolhedor, datainicial: inicial, datafinal: final});
      if (Object.keys(data).length === 0) {
        return 'guuid';
      }
        return new Error('Erro ao criar o registro.');
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError<ErrorResponse>;
        if (axiosError.response) {
          const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
          return new Error(errorMessage);
        } else if (axiosError.request) {
          return new Error('Nenhuma resposta do servidor');
        } else {
          return new Error(axiosError.message);
        }
      } else {
        return new Error('Erro inesperado');
      }
    }
  };

  const deleteProducao = async (dataproducao: string): Promise<void | Error> => {
    try {
      await Api.delete(`/producao?dataproducao=${dataproducao}`);
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError<ErrorResponse>;
        if (axiosError.response) {
          const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
          return new Error(errorMessage);
        } else if (axiosError.request) {
          return new Error('Nenhuma resposta do servidor');
        } else {
          return new Error(axiosError.message);
        }
      } else {
        return new Error('Erro inesperado');
      }
    }
  };

  const deleteProducaoIndividual = async (guuidcolhedor: string, dataproducao: string): Promise<void | Error> => {
    try {
      await Api.delete(`/producaoindividual?dataproducao=${dataproducao}&guuidcolhedor=${guuidcolhedor}`);
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError<ErrorResponse>;
        if (axiosError.response) {
          const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
          return new Error(errorMessage);
        } else if (axiosError.request) {
          return new Error('Nenhuma resposta do servidor');
        } else {
          return new Error(axiosError.message);
        }
      } else {
        return new Error('Erro inesperado');
      }
  }
};

export const ProducaoService = {
  getAll,
  GeraProducao,
  deleteProducao,
  producaofazenda,
  GeraProducaoIndividual,
  deleteProducaoIndividual,
  Recibo,
}